import Vue from 'vue'

export const useSizeDefaults = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
}

export const useSizeProps = {
  size: {
    type: String,
    default: 'md'
  }
}

export type useSizeMixin = ReturnType<typeof useSize>

export default function useSize(sizes = useSizeDefaults) {
  // return sizeStyle
  return Vue.extend({
    props: useSizeProps,
    computed: {
      sizeStyle() {
        return this.size !== void 0
          ? { fontSize: this.size in sizes ? `${sizes[this.size]}px` : this.size }
          : null
      }
    }
  })
}
